import { Component, OnInit, ViewChild } from "@angular/core";
import { LocalStorageService } from "angular-2-local-storage";
import * as moment from "moment";
import { switchMap } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { Country } from "../../constant/country.constant";
import { AuthorizedApps } from "../../enum/shared/authorized-apps.enum";
import { BackOfficeRole } from "../../enum/shared/backoffice-role.enum";
import { AuthorizedAppModel } from "../../model/shared/authorized-app.model";
import { PolicyModel } from "../../model/shared/policy.model";
import { PolicyService } from "../../service/policy.service";
import { AddRoleModalComponent } from "./add-role-modal/add-role-modal.component";
import { RoleOperationComponent } from "./role-operation/role-operation.component";

@Component({
    selector: "bo-builk-role-manager",
    templateUrl: "./role-manager.component.html",
    styleUrls: ["./role-manager.component.scss"]
})

export class RoleManagerComponent implements OnInit {
    isToggle: boolean = false;
    main: string = "main-container";
    toggleStyle: string = "text-align:left;";
    policies = new Array<PolicyModel>();
    authorizedApps = new Array<AuthorizedAppModel>();
    authorizedApps2 = new Array<AuthorizedAppModel>();
    canCreateNewUser: boolean;

    @ViewChild("addRoleModal") addRoleModal: AddRoleModalComponent;

    settings = {
        actions: {
            add: false,
            edit: false,
            delete: false
        },
        attr: {
            class: "table table-hover table-sm"
        },
        columns: {
            index: {
                title: "#",
                type: "text",
                filter: false,
                valuePrepareFunction(value, row, cell): number {
                    return cell.row.index + 1;
                },
                sort: false
            },
            userFullName: {
                title: "Name",
                type: "html",
                sortDirection: "asc",
                valuePrepareFunction: (cell, row) => {
                    return `${row.userFullName}`;
                }
            },
            userEmail: {
                title: "Email",
                type: "text"
            },
            userCountry: {
                title: "Country",
                type: "text",
                valuePrepareFunction: (cell, row) => {
                    switch (row.userCountry) {
                        case Country.Thailand: return "Thailand";
                        case Country.Philippines: return "Philippines";
                        case Country.Myanmar: return "Myanmar";
                        case Country.Laos: return "Laos";
                        case Country.All: return "All";
                        default: return "-";
                    }
                },
                filter: false
            },
            userRole: {
                title: "Role",
                type: "text",
                valuePrepareFunction: (cell, row) => {
                    switch (String(row.userRole)) {
                        case String(BackOfficeRole.SuperUser): return "Superuser";
                        case String(BackOfficeRole.Administrator): return "Administrator";
                        case String(BackOfficeRole.Moderator): return "Moderator";
                        default: return "-";
                    }
                },
                filter: false
            },
            // authorizedApps: {
            //     title: "Authorized Applications",
            //     type: "text",
            //     valuePrepareFunction: this.onGetAppName.bind(this),
            //     filter: false
            // },
            createdDate: {
                title: "Created Date",
                type: "date",
                valuePrepareFunction: (cell, row) => {
                    return moment(new Date(row.createdDate))
                        .format("DD-MM-YYYY");
                },
                filter: false
            },
            actions: {
                title: "Actions",
                type: "custom",
                filter: false,
                sort: false,
                renderComponent: RoleOperationComponent
            }
        },
        pager: {
            display: true,
            perPage: 50
        }
    };

    constructor(
        private readonly localStorageService: LocalStorageService,
        private readonly policyService: PolicyService
    ) { }

    ngOnInit(): void {
        this.policyService.getUserPolicies(environment.firebaseConfig.policyCollection)
            .pipe(
                switchMap(response => {
                    this.policies = response;
                    const userPolicy = this.policies.find(f => f.userEmail === this.localStorageService.get<string>("userEmail"));
                    this.policies.forEach(element => {
                        element.currentUserRole = userPolicy.userRole;
                    });

                    return this.policyService.getUserPolicy(environment.firebaseConfig.policyCollection,
                        "userEmail",
                        this.localStorageService.get<string>("userEmail"));
                })
            )
            .subscribe(res => {
                if (res.length > 0) {
                    this.canCreateNewUser = res[0].userRole !== BackOfficeRole.Moderator ? true : false;
                }
            });
    }

    onAddNewRole(): void {
        this.addRoleModal.openModal();
    }

    toggleSidebar(event: boolean): void {
        this.isToggle = event;

        // css main
        this.main = this.isToggle ? "toggle-main-container" : "main-container";
    }

    isToggleEvent(event: boolean): void {
        // css main
        this.main = event ? "toggle-main-container" : "main-container";
    }

    onGetAppName(authorizedApps: Array<AuthorizedAppModel>): string {
        const outputApp = [];
        if (authorizedApps !== undefined) {
            authorizedApps.forEach(element => {
                switch (element.appName) {
                    case AuthorizedApps.Builk: outputApp.push(`Builk (${this.onGetAppCountry(element.country)})`); break;
                    case AuthorizedApps.Jubili: outputApp.push(`Jubili (${this.onGetAppCountry(element.country)})`); break;
                    case AuthorizedApps.Kwanjai: outputApp.push(`Kwanjai (${this.onGetAppCountry(element.country)})`); break;
                    case AuthorizedApps.Intake: outputApp.push(`Intake (${this.onGetAppCountry(element.country)})`); break;
                    default: break;
                }
            });

            return authorizedApps.length > 0 ? outputApp.join(", ") : "-";
        }
    }

    onGetAppCountry(country: Array<string>): string {
        const countries = [];
        if (country !== undefined) {
            if (country.length > 0 && country.find(f => f.includes("all"))) {
                return "All";
            }

            country.forEach(elementCountry => {
                switch (elementCountry) {
                    case Country.All: countries.push("All"); break;
                    case Country.Laos: countries.push("Laos"); break;
                    case Country.Myanmar: countries.push("Myanmar"); break;
                    case Country.Philippines: countries.push("Philippines"); break;
                    case Country.Thailand: countries.push("Thailand"); break;
                    default: return "-";
                }
            });
        }

        return country.length > 0 ? countries.join(", ") : "-";
    }
}
